import React from "react"
import { NavLink } from "react-router-dom"

// Logo da marca (ícone de divisas + "Simulado Militar" em Barlow Condensed),
// a mesma da landing/login. Usada nos headers da área interna.
//
// `to` define o destino do link (default: /dashboard). Passe `to={null}` para
// renderizar estática (sem link) — ex.: durante o simulado, pra não sair por engano.
// `compact` esconde o wordmark abaixo de sm (mostra só o ícone) — útil em headers
// apertados como o do simulado, onde o cronômetro divide espaço no mobile.
export function BrandLogo({ to = "/dashboard", compact = false }: { to?: string | null; compact?: boolean }) {
  const content = (
    <>
      <svg
        viewBox="0 0 24 24"
        className="h-5 w-5 shrink-0 text-gold-500"
        fill="none"
        stroke="currentColor"
        strokeWidth={2.4}
        strokeLinecap="square"
        aria-hidden="true"
      >
        <path d="M4 8.5 12 3.5 20 8.5" />
        <path d="M4 14 12 9 20 14" />
        <path d="M4 19.5 12 14.5 20 19.5" />
      </svg>
      <span
        className={`font-display text-sm font-bold uppercase tracking-[0.18em] text-gold-600 sm:text-base ${
          compact ? "hidden sm:inline" : ""
        }`}
      >
        Simulado Militar
      </span>
    </>
  )

  if (to === null) {
    return (
      <span className="flex items-center gap-2" aria-label="Simulado Militar">
        {content}
      </span>
    )
  }

  return (
    <NavLink to={to} className="flex items-center gap-2" aria-label="Simulado Militar — início">
      {content}
    </NavLink>
  )
}
